module.exports = __webpack_public_path__ + "img/MR.5998aec6.png";